import React, { Component } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';

class Checkbox extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header} = this.props;
      const eventsHandler = {
        onChange:() => (colData.changeHandler) ?
                colData.changeHandler(colData,colData.attributes):
                      'javascript(void)'
      }
        return(
            <td key={"column"+id} style={{minWidth:'20px'}} className="position-relative">
                <input 
                    {...eventsHandler}
                    {...(header.attributes)?{ ...header.attributes}:{}} 
                    {...colData.attributes}
                    className="form-radio-input" type="checkbox" 
                    checked={(colData.checked===true)?true:false}
                    name="checkbbox" value="" style={{"top":"0px"}}></input>
            </td>
        );
    }
}

export default Checkbox;